import type { QuestionNumberModelData } from '@coorum-research/shared-common/types/survey-json.type'
import type { SurveyElementForm } from './survey-element-form'
import { useState } from 'react'
import { ElementHeader } from './ElementHeader'
import { ElementValidationMessage } from './ElementValidationMessage'
import { commonInputClasses } from './survey-element-styles'
import { SurveyElementLayout } from './SurveyElementLayout'

type Props = {
  currentForm: SurveyElementForm
  validationError: string | null
}

export function SurveyElementNumber({
  currentForm,
  validationError,
}: Props) {
  const currentElement = currentForm.elementJson as QuestionNumberModelData
  const [value, setValue] = useState(() => currentForm.getValue() as string)

  const handleOnValueChange = (newValue: string) => {
    setValue(newValue)
    currentForm.setElementResultRecordValue(newValue)
  }

  return (
    <SurveyElementLayout>
      <ElementValidationMessage
        validationError={validationError}
      />
      <ElementHeader
        currentElement={currentElement}
      />
      <input
        type="number"
        className={commonInputClasses}
        value={value}
        min={currentElement.min}
        max={currentElement.max}
        step={currentElement.step}
        placeholder={currentElement.placeholder}
        onChange={e => handleOnValueChange(e.target.value)}
      />
    </SurveyElementLayout>
  )
}
